import { Injectable } from '@angular/core';

import cytoscape from 'cytoscape';
import popper from 'cytoscape-popper';
import tippy from 'tippy.js';

cytoscape.use(popper(tippy));

@Injectable()
export class DiagramService {

	constructor() {
		console.log('DiagramService initialization...');
	}

	initDiagram(params){
		return cytoscape(params);
	}
}
